export class Insurance {
    constructor() {
        this.healthInsuranceCompany = ""; // assigned to
        this.phone = "";
        this.policyNumber = "";
        this.preAuthRequired = false;
        this.additionalInsuranceCoverage = "";
        this.additionalPhone = "";
        this.additionalPolicyNumber = "";
        this.insuranceNotes = "";
    }
    clone() {
        return Insurance.clone(this);
    }
    static clone(source) {
        const theClone = new Insurance();
        theClone.healthInsuranceCompany = source.healthInsuranceCompany || "";
        theClone.phone = source.phone || "";
        theClone.policyNumber = source.policyNumber || "";
        theClone.preAuthRequired = source.preAuthRequired || false;
        theClone.additionalPhone = source.additionalPhone || "";
        theClone.additionalPolicyNumber = source.additionalPolicyNumber || "";
        theClone.additionalInsuranceCoverage = source.additionalInsuranceCoverage || "";
        theClone.insuranceNotes = source.insuranceNotes || "";
        return theClone;
    }
    static load(source) {
        return Insurance.clone(source);
    }
}
//# sourceMappingURL=insurance.js.map